import React, { useState } from "react";
import {
  List,
  useTable,
  EditButton,
  DeleteButton,
  TableColumnType,
  Button,
  Table,
  SaveButton,
  Form,
  Input,
} from "@pankod/refine-antd";
import { useExport } from "@pankod/refine-core";
import { ISearch } from "type";

export const OkxBalanceList = () => {
  const [query, setQuery] = useState("");
  const { tableProps, searchFormProps } = useTable({
    queryOptions: { retry: false },
    onSearch: (values: ISearch) => {
      return [
        {
          field: "q",
          operator: "contains",
          value: values.q ? values.q : null,
        },
      ];
    },
  });
  const { triggerExport } = useExport({
    filters: [
      {
        field: "q",
        operator: "contains",
        value: query,
      },
    ],
  });
  const rows = tableProps.dataSource?.map((row) => ({
    ...row,
    id: row.bot_subscription_id + row.snapped_at,
  }));

  const columns = React.useMemo<TableColumnType<any>[]>(
    () => [
      {
        dataIndex: "bot_subscription_id",
        title: "Bot-subscription Id",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
        fixed: "left",
      },
      {
        dataIndex: "snapped_at",
        title: "Snapped At",
        width: 250,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "available_balance",
        title: "Available Balance",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "available_eq",
        title: "Available Eq",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "cash_balance",
        title: "Cash Balance",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "ccy",
        title: "Ccy",
        width: 70,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "cross_liab",
        title: "Cross Liab",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "eq",
        title: "Eq",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "eq_usd",
        title: "Eq Usd",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "dis_eq",
        title: "Dis Eq",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "frozen_balance",
        title: "Frozen Balance",
        type: "number",
        width: 180,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "interest",
        title: "Interest",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "iso_eq",
        title: "ISO Eq",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "iso_liab",
        title: "ISO Liab",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "iso_upl",
        title: "ISO Upl",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "liaby",
        title: "Liaby",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "max_loan",
        title: "Max Loan",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
        ellipsis: {
          showTitle: false,
        },
      },
      {
        dataIndex: "mgn_ratio",
        title: "Mgn Ratio",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "notional_lever",
        title: "Notional Lever",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "ord_frozen",
        title: "Ord Frozen",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "twap",
        title: "Twap",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "upl",
        title: "Upl",
        type: "number",
        width: 170,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "upl_liab",
        title: "Upl Liab",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "u_time",
        title: "U Time",
        type: "number",
        width: 150,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "stgy_eq",
        title: "Stgy Eq",
        type: "number",
        width: 100,
        align: "center",
        headerAlign: "center",
      },
      {
        dataIndex: "spot_in_use_amt",
        title: "Sport in Use Amt",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return (
    <List
      headerButtons={({ defaultButtons }) => (
        <>
          {defaultButtons}
          <Form {...searchFormProps} layout="inline">
            <Form.Item name="q">
              <Input
                placeholder="Search by ..."
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              />
            </Form.Item>
            <SaveButton type="default" onClick={searchFormProps.form?.submit}>
              SEARCH
            </SaveButton>
          </Form>
          <Button type="primary" onClick={triggerExport}>
            EXPORT
          </Button>
        </>
      )}
    >
      <Table
        {...tableProps}
        bordered={true}
        dataSource={rows}
        columns={columns}
        scroll={{ x: 1500 }}
        size="middle"
        pagination={{
          ...tableProps.pagination,
          position: ["bottomRight"],
          size: "default",
        }}
      ></Table>
    </List>
  );
};
